import React from 'react';
import { Check } from 'lucide-react';
import { Button } from './ui/button';
import { pricingData } from '../data/mockData';

const PricingCard = ({ plan }) => {
  return (
    <div 
      className={`relative p-8 flex flex-col h-full ${
        plan.highlighted 
          ? 'bg-[#c9a962]' 
          : 'bg-[#141414] border border-[#2a2a2a] text-white'
      }`}
    >
      {/* Popular Badge */}
      {plan.highlighted && (
        <div className="absolute -top-4 left-1/2 -translate-x-1/2">
          <span className="bg-[#0a0a0a] text-[#c9a962] text-xs font-medium uppercase tracking-wider px-4 py-2">
            Most Popular
          </span>
        </div>
      )}
      
      {/* Header */}
      <div className="mb-6">
        <h3 className={`heading-2 mb-1 ${plan.highlighted ? 'text-white' : ''}`}>{plan.name}</h3>
        <p className={`body-small ${plan.highlighted ? 'text-white/80' : 'text-[#808080]'}`}>
          {plan.subtitle}
        </p>
      </div>
      
      {/* Price */}
      <div className="mb-6">
        <span className={`text-4xl md:text-5xl font-medium ${plan.highlighted ? 'text-white' : ''}`}>{plan.price}</span>
        <span className={`body-regular ml-2 ${plan.highlighted ? 'text-white/80' : 'text-[#808080]'}`}>
          {plan.period}
        </span>
      </div>
      
      {/* Description */}
      <p className={`body-regular mb-8 ${plan.highlighted ? 'text-white/90' : 'text-[#b3b3b3]'}`}>
        {plan.description}
      </p>
      
      {/* Features */}
      <ul className="space-y-4 mb-8 flex-grow">
        {plan.features.map((feature, index) => (
          <li key={index} className="flex items-start gap-3">
            <div className={`flex-shrink-0 w-5 h-5 flex items-center justify-center ${
              plan.highlighted ? 'bg-white' : 'bg-[#c9a962]'
            }`}>
              <Check size={12} className={plan.highlighted ? 'text-[#c9a962]' : 'text-[#0a0a0a]'} />
            </div>
            <span className={`body-regular ${plan.highlighted ? 'text-white' : ''}`}>{feature}</span>
          </li>
        ))}
      </ul>
      
      {/* CTA */}
      <Button 
        asChild
        className={`w-full rounded-none py-4 h-auto text-sm font-medium transition-all duration-300 ${
          plan.highlighted 
            ? 'bg-white text-[#0a0a0a] hover:bg-white/90 border-none' 
            : 'bg-transparent text-[#c9a962] border border-[#c9a962] hover:bg-[#c9a962] hover:text-[#0a0a0a]'
        }`}
      >
        <a href="#contact">{plan.cta}</a>
      </Button>
    </div>
  );
};

const Pricing = () => {
  return (
    <section id="pricing" className="section-padding bg-[#111111]">
      <div className="container">
        {/* Header */}
        <div className="text-center max-w-2xl mx-auto mb-16">
          <span className="inline-block text-sm font-medium text-[#c9a962] tracking-wider uppercase mb-4">
            Pricing
          </span>
          
          <h2 className="heading-1 text-white mb-6">
            Investment in Your Brand
          </h2>
          
          <p className="body-large text-[#b3b3b3]">
            Transparent pricing for every stage of your business. All packages can be customised to your specific needs.
          </p>
        </div>
        
        {/* Pricing Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-8 max-w-5xl mx-auto">
          {pricingData.map((plan) => (
            <PricingCard key={plan.id} plan={plan} />
          ))}
        </div>
        
        {/* Custom Note */}
        <div className="text-center mt-12">
          <p className="body-regular text-[#808080]">
            Need something different?{' '}
            <a href="#contact" className="text-[#c9a962] underline underline-offset-4 hover:no-underline">
              Let's discuss a custom package
            </a>
          </p>
        </div>
      </div>
    </section>
  );
};

export default Pricing;
